import { render, staticRenderFns } from "./SystemSettingsPolicyVerifiedEmail.vue?vue&type=template&id=12d9ed44&scoped=true&"
import script from "@/scripts/modal/systemSettingsPolicyVerifiedEmail.js?vue&type=script&lang=js&"
export * from "@/scripts/modal/systemSettingsPolicyVerifiedEmail.js?vue&type=script&lang=js&"
import style0 from "./SystemSettingsPolicyVerifiedEmail.vue?vue&type=style&index=0&id=12d9ed44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9ed44",
  null
  
)

export default component.exports